import type { CollapsedHeader } from '../../editor/useHeaderCollapse';

const getReversedPrecedingHeaders = (
  element: HTMLElement,
  headers: CollapsedHeader[],
) =>
  headers
    .filter(
      (header) =>
        element.compareDocumentPosition(header.domNode) & // eslint-disable-line no-bitwise
        Node.DOCUMENT_POSITION_PRECEDING,
    )
    .toReversed();

const getCollapsedHeaderRect = (
  element: HTMLElement,
  collapsedHeaders: CollapsedHeader[],
) => {
  const isWithinCollapsedHeader = !element.offsetParent;
  if (!isWithinCollapsedHeader) return null;

  const visibleCollapsedHeaders = collapsedHeaders.filter(
    (header) => !!header.domNode.offsetParent,
  );

  const header = getReversedPrecedingHeaders(
    element,
    visibleCollapsedHeaders,
  )[0];

  return header?.domNode.getBoundingClientRect() ?? null;
};

export default getCollapsedHeaderRect;
